import React, { useState, useEffect } from "react";
import "../css/faqs.css";
import config from "../config/config";
import {
  Sheet,
  Scrollable,
  Heading,
  Button,
  Page,
  Link,
} from "@shopify/polaris";
import { QuestionMarkMajor, MobileCancelMajor } from "@shopify/polaris-icons";
import Tutorials from "./HelpCenter/Tutorials";
import FAQs from "./HelpCenter/FAQs";

const HelpCenter = (props) => {
  const [sheetActive, setSheetActive] = useState(false);
  const [tab, setTab] = useState("faqs");
  useEffect(() => {
    setSheetActive(props.openFaqs);
  }, [props.openFaqs]);

  const liveChat = () => {
    window.open("http://m.me/omegatheme", "_blank");
  };
  const closeSheet = () => {
    setSheetActive(false);
    // props.closeSheet(false);
  };

  return (
    <div className="faq-button">
      <div className="group-btn">
        <div className="otGroupButton">
          <div
            group-id={5305}
            data-scroll={0}
            style={{ bottom: "35%" }}
            className="cta_group_preview  display_everywhere vertical position_right medium style2"
          >
            {/* <div
              onClick={() => setSheetActive(true)}
              id="omega-cta-button-21661"
              data-tooltip-location="left"
              btn-id={21661}
              data-ga="disable"
              data-fa="disable"
              data-type="home"
              href="#"
              className="ot-btn-item  hover_text has_text icon_text home"
              style={{
                boxSizing: "border-box",
                backgroundColor: "rgba(255, 255, 255, 1)",
                position: "relative",
                display: "block",
              }}
            >
              <div className="ot-btn-item-child">
                <div
                  className="ot-btn-icon"
                  style={{ color: "#212121", fill: "#212121" }}
                >
                  <svg
                    width="48px"
                    height="48px"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fal"
                    data-icon="home-lg"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    className="svg-inline--fa fa-home-lg fa-w-18 fa-9x"
                  >
                    <path
                      fill="currentColor"
                      d="M573.48 219.91L512 170.42V72a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v72.6L310.6 8a35.85 35.85 0 0 0-45.19 0L2.53 219.91a6.71 6.71 0 0 0-1 9.5l14.2 17.5a6.82 6.82 0 0 0 9.6 1L64 216.72V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V216.82l38.8 31.29a6.83 6.83 0 0 0 9.6-1l14.19-17.5a7.14 7.14 0 0 0-1.11-9.7zM336 480h-96V320h96zm144 0H368V304a16 16 0 0 0-16-16H224a16 16 0 0 0-16 16v176H96V190.92l187.71-151.4a6.63 6.63 0 0 1 8.4 0L480 191z"
                    />
                  </svg>
                </div>
                <div
                  className="ot-btn-text-icon truncate"
                  style={{ color: "#212121" }}
                >
                  Help Center
                </div>
              </div>
            </div> */}
            {/* 
            <a
              id="omega-cta-button-19944"
              data-tooltip-location="left"
              btn-id={19944}
              target="_blank"
              data-type="whatsapp"
              href={
                "https://web.whatsapp.com/send?phone=+84965607495&text=I need support for SyncTrack - Add Tracking Auto app. My store is " +
                config.shop
              }
              className="ot-btn-item  hover_text has_text icon_text whatsapp"
              style={{
                boxSizing: "border-box",
                backgroundColor: "rgba(53, 171, 67, 1)",
                position: "relative",
                display: "block",
              }}
            >
              <div className="ot-btn-item-child">
                <div
                  className="ot-btn-icon"
                  style={{ color: "#ffffff", fill: "#ffffff" }}
                >
                  <svg
                    width="48px"
                    height="48px"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fab"
                    data-icon="whatsapp"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    className="svg-inline--fa fa-whatsapp fa-w-14 fa-9x"
                  >
                    <path
                      fill="currentColor"
                      d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                    />
                  </svg>
                </div>
                <div
                  className="ot-btn-text-icon truncate"
                  style={{ color: "#ffffff" }}
                >
                  Whatsapp chat
                </div>
              </div>
            </a> */}
            {/* <a
              target="_blank"
              id="omega-cta-button-19945"
              data-tooltip-location="left"
              btn-id={19945}
              data-type="facebook"
              href="http://m.me/omegatheme"
              className="ot-btn-item  hover_text has_text icon_text facebook"
              style={{
                boxSizing: "border-box",
                backgroundColor: "rgba(0, 132, 255, 1)",
                position: "relative",
                display: "block",
              }}
            >
              <div className="ot-btn-item-child">
                <div
                  className="ot-btn-icon"
                  style={{ color: "#ffffff", fill: "#ffffff" }}
                >
                  <svg
                    width="48px"
                    height="48px"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fab"
                    data-icon="facebook-messenger"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    className="svg-inline--fa fa-facebook-messenger fa-w-16 fa-9x"
                  >
                    <path
                      fill="currentColor"
                      d="M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
                    />
                  </svg>
                </div>
                <div
                  className="ot-btn-text-icon truncate"
                  style={{ color: "#ffffff" }}
                >
                  FB Live chat
                </div>
              </div>
            </a>
            <a
              id="omega-cta-button-21659"
              data-tooltip-location="left"
              btn-id={21659}
              data-ga="disable"
              data-fa="disable"
              data-type="email"
              href="mailto:contact@omegatheme.com"
              className="ot-btn-item  hover_text has_text icon_text email"
              style={{
                boxSizing: "border-box",
                backgroundColor: "rgba(255, 255, 255, 1)",
                position: "relative",
                display: "block",
              }}
            >
              <div className="ot-btn-item-child">
                <div
                  className="ot-btn-icon"
                  style={{ color: "#212121", fill: "#212121" }}
                >
                  <svg
                    width="48px"
                    height="48px"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="far"
                    data-icon="envelope"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    className="svg-inline--fa fa-envelope fa-w-16 fa-9x"
                  >
                    <path
                      fill="currentColor"
                      d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
                    />
                  </svg>
                </div>
                <div
                  className="ot-btn-text-icon truncate"
                  style={{ color: "#000" }}
                >
                  Send Email
                </div>
              </div>
            </a> */}
          </div>
        </div>
      </div>
      <Page narrowWidth>
        <Sheet
          open={sheetActive}
          onClose={() => closeSheet()}
          accessibilityLabel="Manage sales channels"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <div
              style={{
                alignItems: "center",
                borderBottom: "1px solid #DFE3E8",
                display: "flex",
                justifyContent: "space-between",
                padding: "1.6rem",
                width: "100%",
              }}
            >
              <Heading>Help Center</Heading>
              <Button
                accessibilityLabel="Cancel"
                icon={MobileCancelMajor}
                onClick={() => setSheetActive(false)}
                plain
              />
            </div>
            {/* <div className="help-desk">
              <div className="help-desk__widgets">
                <button
                  onClick={() => setTab("faqs")}
                  className="help-desk__widget"
                >
                  <div className="box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                    </svg>
                  </div>
                  <p>FAQ</p>
                </button>
                <button
                  onClick={() => setTab("tutorials")}
                  className="help-desk__widget"
                >
                  <div className="box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      ></circle>
                      <polygon
                        points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      ></polygon>
                    </svg>
                  </div>
                  <p>Tutorials</p>
                </button>
                <button
                  onClick={() => liveChat()}
                  className="help-desk__widget"
                >
                  <div className="box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                    </svg>
                  </div>
                  <p>Live Chat Support</p>
                </button>
              </div>
            </div> */}
            <Scrollable style={{ padding: "1.6rem", height: "100%" }}>
              {tab === "tutorials" ? <Tutorials /> : <FAQs />}
            </Scrollable>
            <div
              style={{
                alignItems: "center",
                borderTop: "1px solid #DFE3E8",
                display: "flex",
                justifyContent: "space-between",
                padding: "1.6rem",
                width: "100%",
              }}
            >
              <Button onClick={() => setSheetActive(false)}>Close</Button>
            </div>
          </div>
        </Sheet>
      </Page>
    </div>
  );
};

export default HelpCenter;
